export const RestrictedUserEmails = [
  "anthem_agent@internal.org",
  "bcbsri_agent@internal.org",
  "wellpoint_agent@internal.org",
  "aetna_agent@internal.org",
  "regence_agent@internal.org",
  "nextblue_agent@internal.org",
  "wellmarkadvantage_agent@internal.org",
  "wyoblueadvantage_agent@internal.org",
];

export const RestrictedUserNames = [
  "Anthem Agent",
  "BCBSRI Agent",
  "Wellpoint Agent",
  "Aetna Agent",
  "Regence Agent",
  "NextBlue Agent",
  "WellmarkAdvantage Agent",
  "WyoblueAdvantage Agent"
];